function stringToKebabCase(value: string | undefined): string | undefined {
  if (!value) {
    return value;
  }
  return value.toLowerCase().split(' ').join('-');
}

export default stringToKebabCase;
